import { LanguageApi } from 'src/api';
import { toDetailedSourceLanguages } from 'src/api/conversion';
import { DetailedSourceLanguageResponse } from 'src/types/languagesDomain';
import { LanguagePairProviderProps } from 'src/context/languagePair';
import { LANGUAGE_PAIRS_SLUGS } from 'src/constants/languagePairsSlugs.const';

export type ReturnedProviderProps = LanguagePairProviderProps & {
  languagePairs: DetailedSourceLanguageResponse[];
};

export const getProviderServerSideProps = async ({
  sourceLanguageLocale,
  targetLanguageLocale,
}: {
  sourceLanguageLocale: string;
  targetLanguageLocale: string;
}): Promise<ReturnedProviderProps | undefined> => {
  const languagePairsResponse = await LanguageApi.getSourceLanguage(sourceLanguageLocale);
  const apiLanguagePairs = toDetailedSourceLanguages(languagePairsResponse);
  const languagePairs = apiLanguagePairs.filter(
    lp => LANGUAGE_PAIRS_SLUGS[lp.sourceLanguageLocale][lp.targetLanguageLocale],
  );

  const languagePair = languagePairs.find(lp => lp.targetLanguageLocale === targetLanguageLocale);

  if (languagePair) {
    return {
      languagePair,
      languagePairs,
    };
  }
};
